import React from 'react';
import _ from "underscore";

const Debug = (props) => {
    const childBlocks = _.values(props.blocks).map((Block, id) => <Block.component context={props.context} key={id} />);

    if (childBlocks.length > 0) {
        return (
            <category name='Debug Tools' id='debugTools' iconclass='category with-icon-paths snap-icon-debug_dual'>
                <label text="Debug Tools"/>
                { childBlocks }
            </category>
        );
    }
    
    return null;
};

export default Debug;